import { render, staticRenderFns } from "./factura_cliente.vue?vue&type=template&id=31d02657&"
import script from "./factura_cliente.vue?vue&type=script&lang=js&"
export * from "./factura_cliente.vue?vue&type=script&lang=js&"
import style0 from "./factura_cliente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports